// 引入 axios
import axios from "axios";



let base = 'http://172.27.48.12:37798';
// let base = 'https://086022.xyz:37799';

//传送json格式的get请求
export const getRequest=(url,params)=>{
    return axios({
        method:'get',
        url:`${base}${url}`,
        data: params,
    })
}
